/**
 * Fetch the list of establishments
 * @param {string} API_BASE 
 */
const GetEtablissements = async (API_BASE) => {
    try {
        const response = await fetch(`${API_BASE}/etablissements`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json'
            }
        });

        if (!response.ok) {
            const errorText = await response.text();
            throw new Error(errorText || `HTTP error! status: ${response.status}`);
        }

        var data = await response.json();
        if (data != null) data = [...data.sort((a, b) => a.name.localeCompare(b.name))];
        return data; // Expected to be an array of models.Etablissement
    } catch (error) {
        console.error("Error fetching establishments:", error);
        throw error;
    }
};

export default GetEtablissements;
